import {createFeatureSelector, createSelector} from "@ngrx/store";
import {MessageCountFeatureKey} from "./message-count.reducer";
import {MessageCount} from "../../models/MessageCount";

export const MessageCountSelector = createFeatureSelector<MessageCount[]>(MessageCountFeatureKey);
